import React from 'react';
import { Container, Header, HeaderMinimized, LatestFormRow, H2HRow } from './H2HTableSimple';
import { SVGRadarChart } from '../SVGRadarChart';
import styled from 'styled-components';

const RadarChartWrapper = styled.div`
    text-align: center;
    background-color: ${props => props.theme.statTableBgColor};
    padding: 30px 0;
    box-sizing: border-box;
    overflow: visible;
`;

const Rows = ({ dataset, chartHeight, isAxesLines, isAxesDots, isScaleLines, isDashedCircle, isH2H }) => {
    return (
        <RadarChartWrapper>
            <SVGRadarChart
                stats={dataset}
                chartHeight={chartHeight}
                isAxesLines={isAxesLines}
                isAxesDots={isAxesDots}
                isScaleLines={isScaleLines}
                isDashedCircle={isDashedCircle}
                isH2H={isH2H}
                colorScheme="statsTable"
            />
        </RadarChartWrapper>
    );
};

export default { Container, Header, HeaderMinimized, LatestFormRow, Rows, H2HRow };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/h2h/H2HRadarChart.js
 **/